let handleAgentListResponse: (names: string[], statuses: string[], types: number[]) => void;

export const setHandleAgentListResponse = (
  handler: (names: string[], statuses: string[], types: number[]) => void
) => {
  handleAgentListResponse = handler;
};

export const triggerHandleAgentListResponse = (names: string[], statuses: string[], types: number[]) => {
  if (handleAgentListResponse) {
    handleAgentListResponse(names, statuses, types);
  } else {
    console.warn("Agent list handler is not set");
  }
};
